<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Automation Development</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>Automation Development</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>Automation in software development</h3>
                    <p>Automation in software development is a way to minimize errors during the software development
                        process, make it faster
                        and more cost-efficient, and improve team collaboration and productivity.
                        ScienceSoft offers comprehensive services around the most popular SDLC automation practices -
                        low-code development, test
                        automation, and CI/CD implementation.
                    </p>


                    <div class="services-details-features">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="features-image">
                                    <img src="assets/img/services-details/services-details-2.jpg" alt="image">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <ul class="features-list">
                                    <li><i class="flaticon-check"></i> Low-code development</li>
                                    <li><i class="flaticon-check"></i> CI/CD implementation</li>
                                    <li><i class="flaticon-check"></i> Test automation</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-information">
                    <ul class="services-list">
                        <li><a routerLink="/technology-expertise" class="active">Related Technology Expertise</a></li>
                        <li><a routerLink="/technology-expertise">Angular</a></li>
                        <li><a routerLink="/technology-expertise">Java</a></li>
                        <li><a routerLink="/technology-expertise">.Net</a></li>
                        <li><a routerLink="/technology-expertise">NodeJS</a></li>
                        <li><a routerLink="/technology-expertise">MSSQL</a></li>
                        <li><a routerLink="/technology-expertise">MySQL</a></li>
                        <li><a routerLink="/technology-expertise">Azure Devops</a></li>
                    </ul>

                    <app-services-contact-info></app-services-contact-info>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/web-development-services">
                            <img src="assets/img/services/services-7.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3><a routerLink="/web-development-services">Web Application Development</a></h3>
                        <span>Using Java, .Net, Angular, NodeJS etc</span>
                    </div>
                </div>
            </div>


            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/desktop-development-services">
                            <img src="assets/img/services/services-9.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/desktop-development-services">Desktop Application Development</a>
                        </h3>
                        <span>Using .Net, Java</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/mobile-development-services">
                            <img src="assets/img/services/services-8.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/mobile-development-services">Mobile Application Development</a>
                        </h3>
                        <span>Using Android, IOS etc</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->